<section class="px-0">
  <div class="risk-analysis-pymes">
    <form [formGroup]="riskAnalysisForm" class="max-w-full">
      <div class="risk-analysis-pymes__section risk-analysis-pymes__section--not-padding-bottom">
        <div class="risk-analysis-pymes__header">
          <h2>{{ 'NEW_CONTRACTS.RISK_ANALYSIS_TITLE' | i18nextEager }}</h2>
          <span *ngIf="!draftLoaded">
            <img *ngIf="!riskAnalysisForm?.controls.cups.valid && riskAnalysisForm?.controls.cups.disabled"
              src="/assets/icons/broom.svg" alt="{{ 'NEW_CONTRACTS.CLEAR_FORM' | i18nextEager }}" />
            <img *ngIf="
                (riskAnalysisForm?.controls.cups.valid && riskAnalysisForm?.controls.cups.enabled) ||
                (riskAnalysisForm?.controls.cif.valid && riskAnalysisForm?.controls.cif.enabled)
              " class="pointer" src="/assets/icons/broom-red.svg" alt="{{ 'NEW_CONTRACTS.CLEAR_FORM' | i18nextEager }}"
              (click)="deleteForm()" />
          </span>
        </div>
        <div class="risk-analysis-pymes__center">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_CONTRACTS.CUPS' | i18nextEager }}</mat-label>
            <input matInput formControlName="cups" maxlength="22" uppercase />
            <span matSuffix (click)="openInfo()" class="pointer">
              <img src="/assets/icons/info.svg" class="suffix-icon" alt="" />
            </span>
            <mat-error *ngIf="
                riskAnalysisForm?.controls.cups.errors?.required &&
                (riskAnalysisForm?.controls.cups.touched || riskAnalysisForm?.controls.cups.dirty)
              ">
              {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
            </mat-error>
            <mat-error *ngIf="
                riskAnalysisForm?.controls.cups.errors?.not_ofertable &&
                (riskAnalysisForm?.controls.cups.touched || riskAnalysisForm?.controls.cups.dirty)
              ">
              {{ riskAnalysisForm.controls.cups.errors.not_ofertable }}
            </mat-error>
            <mat-error *ngIf="
                riskAnalysisForm?.controls.cups.errors?.invalid_cups &&
                !riskAnalysisForm?.controls.cups.errors?.required &&
                (riskAnalysisForm?.controls.cups.touched || riskAnalysisForm?.controls.cups.dirty)
              ">
              {{ 'NEW_CONTRACTS.CUPS_ERROR_2' | i18nextEager }}
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_CONTRACTS.CIF' | i18nextEager }}</mat-label>
            <input matInput formControlName="cif" maxlength="9" />
            <mat-error *ngIf="
                riskAnalysisForm?.controls.cif.errors?.required &&
                (riskAnalysisForm?.controls.cif.touched || riskAnalysisForm?.controls.cif.dirty)
              ">
              {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
            </mat-error>
            <mat-error *ngIf="
                riskAnalysisForm?.controls.cif.errors?.invalid_cif &&
                (riskAnalysisForm?.controls.cif.touched || riskAnalysisForm?.controls.cif.dirty)
              ">
              {{ 'NEW_CONTRACTS.CIF_ERROR' | i18nextEager }}
            </mat-error>
            <mat-hint *ngIf="riskAnalysisForm?.controls.cif.errors?.invalid_cif_back === '00000'" class="hint-error">
              {{ 'NEW_CONTRACTS.CIF_ERROR_00000' | i18nextEager }}
            </mat-hint>
          </mat-form-field>
          <app-custom-select *ngIf="!isUserSpanish" class="width100" [label]="'NEW_CONTRACTS.TENSION'"
            [controlName]="'tension'" [values]="tensionList" [defaultValue]="riskAnalysisForm.get('tension').value"
            [disabled]="riskAnalysisForm.get('tension').disabled" (onChange)="onChangeTension($event)">
          </app-custom-select>
          <app-custom-select *ngIf="!isUserSpanish" class="width100" [label]="'NEW_CONTRACTS.CYCLE'"
            [controlName]="'cycle'" [values]="cycleList" [defaultValue]="riskAnalysisForm.get('cycle').value"
            [disabled]="riskAnalysisForm.get('cycle').disabled" (onChange)="onChangeCycle($event)">
          </app-custom-select>
          <app-custom-select *ngIf="!isUserSpanish" class="width100" [label]="'NEW_CONTRACTS.PERIOD'"
            [controlName]="'period'" [values]="periodList" [defaultValue]="riskAnalysisForm.get('period').value"
            [disabled]="riskAnalysisForm.get('period').disabled" (onChange)="onChangePeriod($event)">
          </app-custom-select>
          <app-custom-select *ngIf="!isUserSpanish" class="width100" [label]="'NEW_CONTRACTS.POTENCY'"
            [controlName]="'potency'" [values]="potencyList" [defaultValue]="riskAnalysisForm.get('potency').value"
            [disabled]="riskAnalysisForm.get('potency').disabled" (onChange)="onChangePotency($event)">
          </app-custom-select>
          <mat-form-field *ngIf="riskAnalysisForm.get('potency').value === 'Otro'" appearance="outline">
            <mat-label>{{ 'NEW_CONTRACTS.CUSTOM_POTENCY' | i18nextEager }}</mat-label>
            <input matInput formControlName="customPotency" numberCustom [regex]="regexTwoDecimal"
              [formControl]="riskAnalysisForm.get('customPotency')" />
            <mat-error *ngIf="
                riskAnalysisForm.get('customPotency').errors?.required &&
                (riskAnalysisForm.get('customPotency')?.touched || riskAnalysisForm.get('customPotency')?.dirty)
              ">
              {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
            </mat-error>
            <mat-error *ngIf="
                riskAnalysisForm.get('customPotency').errors?.pattern &&
                (riskAnalysisForm.get('customPotency').touched || riskAnalysisForm.get('customPotency').dirty)
              ">
              {{ 'COMMONS.FORMAT_FIELD' | i18nextEager }}
            </mat-error>
            <mat-error *ngIf="
                riskAnalysisForm.get('customPotency').errors?.min &&
                !riskAnalysisForm.get('customPotency').errors?.pattern &&
                (riskAnalysisForm.get('customPotency').touched || riskAnalysisForm.get('customPotency').dirty)
              ">
              {{ 'NEW_CONTRACTS.MIN_POTENCY' | i18nextEager }} {{ minPotency }}
            </mat-error>
          </mat-form-field>
          <mat-form-field *ngIf="!isUserSpanish" appearance="outline">
            <mat-label>{{ 'NEW_CONTRACTS.CONSUMPTION_ANUAL' | i18nextEager }}</mat-label>
            <input matInput formControlName="consumption" numberCustom [regex]="regexThreeDecimal"
              [formControl]="riskAnalysisForm.get('consumption')" />
            <mat-error *ngIf="
                riskAnalysisForm.get('consumption').errors?.required &&
                (riskAnalysisForm.get('consumption').touched || riskAnalysisForm.get('consumption').dirty)
              ">
              {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
            </mat-error>
            <mat-error *ngIf="
                riskAnalysisForm.get('consumption').errors?.pattern &&
                (riskAnalysisForm.get('consumption').touched || riskAnalysisForm.get('consumption').dirty)
              ">
              {{ 'COMMONS.FORMAT_FIELD' | i18nextEager }}
            </mat-error>
          </mat-form-field>
          <mat-form-field *ngIf="isUserSpanish" appearance="outline">
            <mat-label>{{ 'NEW_CONTRACTS.TOTAL_CONSUMPTION' | i18nextEager }}</mat-label>
            <input matInput formControlName="consumption" />
            <span matSuffix class="bold">
              kWh
            </span>
          </mat-form-field>
          <div *ngIf="isUserSpanish" class="risk-analysis-pymes__consumption-power">
            <div class="risk-analysis-pymes__consumption-power-box">
              <h4 class="risk-analysis-pymes__consumption-power-title">
                {{ 'NEW_CONTRACTS.CONSUMPTION-POWER-INFO.CONSUMPTION' | i18nextEager }} (kWh)
              </h4>
              <div class="risk-analysis-pymes__consumption-power-content">
                <div *ngFor="let consumption of [0, 1, 2, 3, 4, 5]"
                  class="risk-analysis-pymes__consumption-power-period">
                  <p class="risk-analysis-pymes__consumption-power-period-title">
                    {{ 'NEW_CONTRACTS.CONSUMPTION-POWER-INFO.P' | i18nextEager }}{{ consumption + 1 }}
                  </p>
                  <p class="risk-analysis-pymes__consumption-power-period-value">
                    {{
                    estimatedConsumption?.length > 0 && estimatedConsumption[consumption] !== 0
                    ? (estimatedConsumption[consumption] | number)
                    : ''
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div class="risk-analysis-pymes__consumption-power-box">
              <h4 class="risk-analysis-pymes__consumption-power-title">
                {{ 'NEW_CONTRACTS.CONSUMPTION-POWER-INFO.POWER' | i18nextEager }} (kw)
              </h4>
              <div class="risk-analysis-pymes__consumption-power-content">
                <div *ngFor="let power of [0, 1, 2, 3, 4, 5]" class="risk-analysis-pymes__consumption-power-period">
                  <p class="risk-analysis-pymes__consumption-power-period-title">
                    {{ 'NEW_CONTRACTS.CONSUMPTION-POWER-INFO.P' | i18nextEager }}{{ power + 1 }}
                  </p>
                  <p class="risk-analysis-pymes__consumption-power-period-value">
                    {{
                    contractPotency?.length > 0 && contractPotency[power] !== 0
                    ? (contractPotency[power] | number)
                    : ''
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="risk-analysis-pymes__analysis">
            <span class="label">{{ 'NEW_CONTRACTS.ANALYSIS' | i18nextEager }}</span>
            <div class="approved">
              <span *ngIf="!showApproved"></span>
              <span *ngIf="queryApproved.value && showApproved" class="approved__text">
                <img src="/assets/icons/approved.svg" alt="" />
                {{ 'NEW_CONTRACTS.APPROVED' | i18nextEager }}
              </span>
              <span *ngIf="!queryApproved.value && showApproved" class="approved__text">
                <img src="/assets/icons/rejected.svg" alt="" />
                {{ 'NEW_CONTRACTS.REJECTED' | i18nextEager }}
              </span>
              <button class="button-query" [ngClass]="{
                  'button-query--enabled': this.canQueryCredit() && enableQueryButton
                }" (click)="queryCredit()" [disabled]="this.canQueryCredit(true) || !enableQueryButton">
                {{ 'NEW_CONTRACTS.QUERY' | i18nextEager }}
              </button>
            </div>
          </div>
          <app-custom-select *ngIf="!hasTDString(tarifaSipsReal) && isUserSpanish" class="width100"
            [label]="'NEW_CONTRACTS.RESUME_DIALOG.ACCESS_FEE'" [controlName]="'fee'" [values]="feeList"
            [defaultValue]="riskAnalysisForm.get('fee').value" [disabled]="riskAnalysisForm.get('fee').disabled"
            (onChange)="subscribeToFee($event)"></app-custom-select>
          <mat-form-field *ngIf="hasTDString(tarifaSipsReal) && isUserSpanish" appearance="outline">
            <mat-label>{{ 'NEW_CONTRACTS.RESUME_DIALOG.ACCESS_FEE' | i18nextEager }}</mat-label>
            <input matInput formControlName="fee" readonly />
          </mat-form-field>
          <div class="risk-analysis-pymes__select-date">
            <mat-radio-group aria-label="" formControlName="radioDate">
              <mat-radio-button value="1" [disabled]="riskAnalysisForm.get('radioDate').disabled">
                {{ 'NEW_CONTRACTS.READING_CYCLE' | i18nextEager }}
              </mat-radio-button>
              <mat-radio-button value="2" [disabled]="riskAnalysisForm.get('radioDate').disabled">
                {{ 'NEW_CONTRACTS.FUTURE_DATE' | i18nextEager }}
              </mat-radio-button>
            </mat-radio-group>
            <ng-container *ngIf="riskAnalysisForm.get('radioDate').value === '2'">
              <mat-form-field #futureDateField appearance="outline" [ngClass]="{
                  'risk-analysis-pymes__fix-label':
                    riskAnalysisForm?.controls.invoiceDate.invalid &&
                    !(riskAnalysisForm?.controls.invoiceDate.touched || riskAnalysisForm?.controls.invoiceDate.dirty)
                }">
                <mat-label>{{ 'NEW_CONTRACTS.FUTURE_DATE' | i18nextEager }}</mat-label>
                <input formControlName="invoiceDate" matInput [matDatepicker]="picker" [min]="today" readonly />
                <img src="/assets/icons/calendar.svg" class="calendar-icon" (click)="picker.open()"
                  alt="{{ 'COMMONS.CALENDAR' | i18nextEager }}" />
                <mat-datepicker #picker></mat-datepicker>
                <mat-error *ngIf="
                    riskAnalysisForm?.controls.invoiceDate.errors?.required &&
                    (riskAnalysisForm?.controls.invoiceDate.touched || riskAnalysisForm?.controls.invoiceDate.dirty)
                  ">
                  {{ 'NEW_CONTRACTS.INVOICE_DATA_ERROR' | i18nextEager }}
                </mat-error>
              </mat-form-field>
            </ng-container>
          </div>
          <app-custom-select class="width100" [label]="'NEW_CONTRACTS.CAMPAIGN'" [controlName]="'campaign'"
            [values]="campaignsList" [defaultValue]="defaultValueCampaign" [disabled]="campaignsSelectDisabled"
            (onChange)="changeCampaign($event)"></app-custom-select>
        </div>
      </div>
      <div class="risk-analysis-pymes__center">
        <div *ngIf="!isUserSpanish" class="risk-analysis-pymes__select-date">
          <mat-radio-group aria-label="" formControlName="payment">
            <mat-radio-button value="0" [disabled]="riskAnalysisForm.get('payment')?.disabled">
              {{ 'NEW_CONTRACTS.DOMICILIATION' | i18nextEager }}
            </mat-radio-button>
            <mat-radio-button value="1" [disabled]="riskAnalysisForm.get('payment')?.disabled">
              {{ 'NEW_CONTRACTS.MULTIBANK' | i18nextEager }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
        <div *ngIf="!isUserSpanish && showBankAccountFields" class="risk-analysis-pymes__account">
          <mat-form-field appearance="outline" id="iban">
            <mat-label>{{ 'NEW_CONTRACTS.IBAN' | i18nextEager }}</mat-label>
            <input
              matInput
              uppercase
              id="ibanInput"
              formControlName="iban"
              maxlength="4"
              (paste)="onPasteIBAN($event)"
              (keyup)="bankAccountKeyUp($event, null, 'ibanInput', 'entityInput')"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" id="entity">
            <mat-label>{{ 'NEW_CONTRACTS.ENTITY' | i18nextEager }}</mat-label>
            <input
              matInput
              numeric
              id="entityInput"
              formControlName="entity"
              maxlength="4"
              (paste)="onPasteIBAN($event)"
              (keyup)="bankAccountKeyUp($event, 'ibanInput', 'entityInput', 'officeInput')"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" id="office">
            <mat-label>{{ 'NEW_CONTRACTS.OFFICE' | i18nextEager }}</mat-label>
            <input
              matInput
              numeric
              id="officeInput"
              formControlName="office"
              maxlength="4"
              (paste)="onPasteIBAN($event)"
              (keyup)="bankAccountKeyUp($event, 'entityInput', 'officeInput', 'accountInput')"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" id="account">
            <mat-label>{{ 'NEW_CONTRACTS.ACCOUNT' | i18nextEager }}</mat-label>
            <input
              matInput
              numeric
              id="accountInput"
              formControlName="account"
              [maxlength]="11"
              (paste)="onPasteIBAN($event)"
              (keyup)="
                bankAccountKeyUp(
                  $event,
                  'officeInput',
                  'accountInput',
                  'dcInput'
                )
              "
            />
          </mat-form-field>
          <mat-form-field appearance="outline" id="dc">
            <mat-label>{{ 'NEW_CONTRACTS.DC' | i18nextEager }}</mat-label>
            <input
              matInput
              numeric
              id="dcInput"
              formControlName="dc"
              maxlength="2"
              (paste)="onPasteIBAN($event)"
              (keyup)="bankAccountKeyUp($event, 'accountInput', 'dcInput', null)"
            />
          </mat-form-field>
        </div>
        <div
          class="risk-analysis-pymes__account__error"
          *ngIf="!isUserSpanish"
        >
          <mat-error
            *ngIf="
              checkControlRequired('iban') ||
              checkControlRequired('entity') ||
              checkControlRequired('office') ||
              checkControlRequired('dc') ||
              checkControlRequired('account')
            "
          >
            {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
          </mat-error>
          <mat-error *ngIf="checkControlIban()">
            {{ 'NEW_CONTRACTS.IBAN_ERROR' | i18nextEager }}
          </mat-error>
        </div>
      </div>
      <div *ngIf="campaignBase" class="risk-analysis-pymes__select-calculate-commission">
        <!-- <div *ngIf="fixPrice" class="risk-analysis-pymes__section risk-analysis-pymes__section--red">
          <div class="risk-analysis-pymes__header">
            <h2>{{ 'NEW_CONTRACTS.CALCULATE_COMMISSION' | i18nextEager }}</h2>
          </div>
          <div class="risk-analysis-pymes__center">
            <mat-radio-group aria-label="" formControlName="calculateCommission">
              <mat-radio-button value="1" [disabled]="riskAnalysisForm.get('calculateCommission').disabled">
                {{ 'NEW_CONTRACTS.ENTER_MARGIN' | i18nextEager }}
              </mat-radio-button>
              <mat-radio-button *ngIf="isUserSpanish" value="2"
                [disabled]="riskAnalysisForm.get('calculateCommission').disabled">
                {{ 'NEW_CONTRACTS.MARGIN_PRICE' | i18nextEager }}
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </div> -->
        <app-monopoint-calculate-margin
          *ngIf="riskAnalysisForm.value.calculateCommission === '1'"
          [selectedCampaign]="selectedCampaign"
          [campaignDetail]="campaignDetail"
          [greaterEqual100]="greaterEqual100"
          [geographicZone]="geographicZone"
          [fee]="isUserSpanish ? riskAnalysisForm?.get('fee')?.value : feeAux"
          [enterMarginsDraft]="enterMarginsDraft"
          (enterMargins)="getEnterMargins($event)"
        ></app-monopoint-calculate-margin>
        <ng-container *ngIf="riskAnalysisForm.value.calculateCommission === '2'">
          <div class="risk-analysis-pymes__section">
            <div class="risk-analysis-pymes__header">
              <h2>{{ 'NEW_CONTRACTS.CALCULATE_MARGIN' | i18nextEager }}</h2>
            </div>
            <div class="risk-analysis-pymes__title-terms">
              <div class="risk-analysis-pymes__title-terms--bold">{{ 'NEW_CONTRACTS.PRICE_TE' | i18nextEager }}</div>
            </div>
            <div class="risk-analysis-pymes__space--30"></div>
            <div class="risk-analysis-pymes__grid-col--8 risk-analysis-pymes__gap--20">
              <div class="risk-analysis-pymes__col-span--2">
                <app-custom-select class="width100" [label]="'NEW_CONTRACTS.UNITS_TE'" [controlName]="'unitsTE'"
                  [values]="unitsTE" [defaultValue]="valueUnitsTE">
                </app-custom-select>
              </div>
              <div formGroupName="calculateMargins" class="risk-analysis-pymes__col-span--6">
                <div class="risk-analysis-pymes__grid-col--6 risk-analysis-pymes__gap--30" formGroupName="marginTE">
                  <mat-form-field appearance="outline" [ngClass]="{
                      'risk-analysis-pymes__fix-label':
                        riskAnalysisForm?.get('calculateMargins.marginTE.p1').invalid &&
                        !(
                          riskAnalysisForm?.get('calculateMargins.marginTE.p1').touched ||
                          riskAnalysisForm?.get('calculateMargins.marginTE.p1').dirty
                        )
                    }">
                    <mat-label>P1</mat-label>
                    <input matInput formControlName="p1" numberCustom [regex]="regexSixDecimal"
                      [formControl]="riskAnalysisForm.get('calculateMargins.marginTE.p1')" />
                    <mat-error *ngIf="
                        riskAnalysisForm?.get('calculateMargins.marginTE.p1').errors?.required &&
                        (riskAnalysisForm?.get('calculateMargins.marginTE.p1').touched ||
                          riskAnalysisForm?.get('calculateMargins.marginTE.p1').dirty)
                      ">
                      {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="outline" [ngClass]="{
                      'risk-analysis-pymes__fix-label':
                        riskAnalysisForm?.get('calculateMargins.marginTE.p2').invalid &&
                        !(
                          riskAnalysisForm?.get('calculateMargins.marginTE.p2').touched ||
                          riskAnalysisForm?.get('calculateMargins.marginTE.p2').dirty
                        )
                    }">
                    <mat-label>P2</mat-label>
                    <input matInput formControlName="p2" numberCustom [regex]="regexSixDecimal"
                      [formControl]="riskAnalysisForm.get('calculateMargins.marginTE.p2')" />
                    <mat-error *ngIf="
                        riskAnalysisForm?.get('calculateMargins.marginTE.p2').errors?.required &&
                        (riskAnalysisForm?.get('calculateMargins.marginTE.p2').touched ||
                          riskAnalysisForm?.get('calculateMargins.marginTE.p2').dirty)
                      ">
                      {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="outline" [ngClass]="{
                      'risk-analysis-pymes__fix-label':
                        riskAnalysisForm?.get('calculateMargins.marginTE.p3').invalid &&
                        !(
                          riskAnalysisForm?.get('calculateMargins.marginTE.p3').touched ||
                          riskAnalysisForm?.get('calculateMargins.marginTE.p3').dirty
                        )
                    }">
                    <mat-label>P3</mat-label>
                    <input matInput formControlName="p3" numberCustom [regex]="regexSixDecimal"
                      [formControl]="riskAnalysisForm.get('calculateMargins.marginTE.p3')" />
                    <mat-error *ngIf="
                        riskAnalysisForm?.get('calculateMargins.marginTE.p3').errors?.required &&
                        (riskAnalysisForm?.get('calculateMargins.marginTE.p3').touched ||
                          riskAnalysisForm?.get('calculateMargins.marginTE.p3').dirty)
                      ">
                      {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="outline" [ngClass]="{
                      'risk-analysis-pymes__fix-label':
                        riskAnalysisForm?.get('calculateMargins.marginTE.p4').invalid &&
                        !(
                          riskAnalysisForm?.get('calculateMargins.marginTE.p4').touched ||
                          riskAnalysisForm?.get('calculateMargins.marginTE.p4').dirty
                        )
                    }">
                    <mat-label>P4</mat-label>
                    <input matInput formControlName="p4" numberCustom [regex]="regexSixDecimal"
                      [formControl]="riskAnalysisForm.get('calculateMargins.marginTE.p4')" />
                    <mat-error *ngIf="
                        riskAnalysisForm?.get('calculateMargins.marginTE.p4').errors?.required &&
                        (riskAnalysisForm?.get('calculateMargins.marginTE.p4').touched ||
                          riskAnalysisForm?.get('calculateMargins.marginTE.p4').dirty)
                      ">
                      {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field *ngIf="isUserSpanish" appearance="outline" [ngClass]="{
                      'risk-analysis-pymes__fix-label':
                        riskAnalysisForm?.get('calculateMargins.marginTE.p5').invalid &&
                        !(
                          riskAnalysisForm?.get('calculateMargins.marginTE.p5').touched ||
                          riskAnalysisForm?.get('calculateMargins.marginTE.p5').dirty
                        )
                    }">
                    <mat-label>P5</mat-label>
                    <input matInput formControlName="p5" numberCustom [regex]="regexSixDecimal"
                      [formControl]="riskAnalysisForm.get('calculateMargins.marginTE.p5')" />
                    <mat-error *ngIf="
                        riskAnalysisForm?.get('calculateMargins.marginTE.p5').errors?.required &&
                        (riskAnalysisForm?.get('calculateMargins.marginTE.p5').touched ||
                          riskAnalysisForm?.get('calculateMargins.marginTE.p5').dirty)
                      ">
                      {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field *ngIf="isUserSpanish" appearance="outline" [ngClass]="{
                      'risk-analysis-pymes__fix-label':
                        riskAnalysisForm?.get('calculateMargins.marginTE.p6').invalid &&
                        !(
                          riskAnalysisForm?.get('calculateMargins.marginTE.p6').touched ||
                          riskAnalysisForm?.get('calculateMargins.marginTE.p6').dirty
                        )
                    }">
                    <mat-label>P6</mat-label>
                    <input matInput formControlName="p6" numberCustom [regex]="regexSixDecimal"
                      [formControl]="riskAnalysisForm.get('calculateMargins.marginTE.p6')" />
                    <mat-error *ngIf="
                        riskAnalysisForm?.get('calculateMargins.marginTE.p6').errors?.required &&
                        (riskAnalysisForm?.get('calculateMargins.marginTE.p6').touched ||
                          riskAnalysisForm?.get('calculateMargins.marginTE.p6').dirty)
                      ">
                      {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div *ngIf="isUserSpanish" class="risk-analysis-pymes__title-terms">
              <div class="risk-analysis-pymes__title-terms--bold">{{ 'NEW_CONTRACTS.PRICE_TP' | i18nextEager }}</div>
            </div>
            <div class="risk-analysis-pymes__space--30"></div>
            <div *ngIf="isUserSpanish" class="risk-analysis-pymes__grid-col--8 risk-analysis-pymes__gap--20">
              <div class="risk-analysis-pymes__col-span--2">
                <app-custom-select class="width100" [label]="'NEW_CONTRACTS.UNITS_TP'" [controlName]="'unitsTP'"
                  [values]="unitsTP" [defaultValue]="valueUnitsTP">
                </app-custom-select>
              </div>
              <div formGroupName="calculateMargins" class="risk-analysis-pymes__col-span--6">
                <div class="risk-analysis-pymes__grid-col--6 risk-analysis-pymes__gap--30" formGroupName="marginTP">
                  <mat-form-field appearance="outline" [ngClass]="{
                      'risk-analysis-pymes__fix-label':
                        riskAnalysisForm?.get('calculateMargins.marginTP.p1').invalid &&
                        !(
                          riskAnalysisForm?.get('calculateMargins.marginTP.p1').touched ||
                          riskAnalysisForm?.get('calculateMargins.marginTP.p1').dirty
                        )
                    }">
                    <mat-label>P1</mat-label>
                    <input matInput formControlName="p1" numberCustom [regex]="regexSixDecimal"
                      [formControl]="riskAnalysisForm.get('calculateMargins.marginTP.p1')" />
                    <mat-error *ngIf="
                        riskAnalysisForm?.get('calculateMargins.marginTP.p1').errors?.required &&
                        (riskAnalysisForm?.get('calculateMargins.marginTP.p1').touched ||
                          riskAnalysisForm?.get('calculateMargins.marginTP.p1').dirty)
                      ">
                      {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="outline" [ngClass]="{
                      'risk-analysis-pymes__fix-label':
                        riskAnalysisForm?.get('calculateMargins.marginTP.p2').invalid &&
                        !(
                          riskAnalysisForm?.get('calculateMargins.marginTP.p2').touched ||
                          riskAnalysisForm?.get('calculateMargins.marginTP.p2').dirty
                        )
                    }">
                    <mat-label>P2</mat-label>
                    <input matInput formControlName="p2" numberCustom [regex]="regexSixDecimal"
                      [formControl]="riskAnalysisForm.get('calculateMargins.marginTP.p2')" />
                    <mat-error *ngIf="
                        riskAnalysisForm?.get('calculateMargins.marginTP.p2').errors?.required &&
                        (riskAnalysisForm?.get('calculateMargins.marginTP.p2').touched ||
                          riskAnalysisForm?.get('calculateMargins.marginTP.p2').dirty)
                      ">
                      {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="outline" [ngClass]="{
                      'risk-analysis-pymes__fix-label':
                        riskAnalysisForm?.get('calculateMargins.marginTP.p3').invalid &&
                        !(
                          riskAnalysisForm?.get('calculateMargins.marginTP.p3').touched ||
                          riskAnalysisForm?.get('calculateMargins.marginTP.p3').dirty
                        )
                    }">
                    <mat-label>P3</mat-label>
                    <input matInput formControlName="p3" numberCustom [regex]="regexSixDecimal"
                      [formControl]="riskAnalysisForm.get('calculateMargins.marginTP.p3')" />
                    <mat-error *ngIf="
                        riskAnalysisForm?.get('calculateMargins.marginTP.p3').errors?.required &&
                        (riskAnalysisForm?.get('calculateMargins.marginTP.p3').touched ||
                          riskAnalysisForm?.get('calculateMargins.marginTP.p3').dirty)
                      ">
                      {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="outline" [ngClass]="{
                      'risk-analysis-pymes__fix-label':
                        riskAnalysisForm?.get('calculateMargins.marginTP.p4').invalid &&
                        !(
                          riskAnalysisForm?.get('calculateMargins.marginTP.p4').touched ||
                          riskAnalysisForm?.get('calculateMargins.marginTP.p4').dirty
                        )
                    }">
                    <mat-label>P4</mat-label>
                    <input matInput formControlName="p4" numberCustom [regex]="regexSixDecimal"
                      [formControl]="riskAnalysisForm.get('calculateMargins.marginTP.p4')" />
                    <mat-error *ngIf="
                        riskAnalysisForm?.get('calculateMargins.marginTP.p4').errors?.required &&
                        (riskAnalysisForm?.get('calculateMargins.marginTP.p4').touched ||
                          riskAnalysisForm?.get('calculateMargins.marginTP.p4').dirty)
                      ">
                      {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="outline" [ngClass]="{
                      'risk-analysis-pymes__fix-label':
                        riskAnalysisForm?.get('calculateMargins.marginTP.p5').invalid &&
                        !(
                          riskAnalysisForm?.get('calculateMargins.marginTP.p5').touched ||
                          riskAnalysisForm?.get('calculateMargins.marginTP.p5').dirty
                        )
                    }">
                    <mat-label>P5</mat-label>
                    <input matInput formControlName="p5" numberCustom [regex]="regexSixDecimal"
                      [formControl]="riskAnalysisForm.get('calculateMargins.marginTP.p5')" />
                    <mat-error *ngIf="
                        riskAnalysisForm?.get('calculateMargins.marginTP.p5').errors?.required &&
                        (riskAnalysisForm?.get('calculateMargins.marginTP.p5').touched ||
                          riskAnalysisForm?.get('calculateMargins.marginTP.p5').dirty)
                      ">
                      {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="outline" [ngClass]="{
                      'risk-analysis-pymes__fix-label':
                        riskAnalysisForm?.get('calculateMargins.marginTP.p6').invalid &&
                        !(
                          riskAnalysisForm?.get('calculateMargins.marginTP.p6').touched ||
                          riskAnalysisForm?.get('calculateMargins.marginTP.p6').dirty
                        )
                    }">
                    <mat-label>P6</mat-label>
                    <input matInput formControlName="p6" numberCustom [regex]="regexSixDecimal"
                      [formControl]="riskAnalysisForm.get('calculateMargins.marginTP.p6')" />
                    <mat-error *ngIf="
                        riskAnalysisForm?.get('calculateMargins.marginTP.p6').errors?.required &&
                        (riskAnalysisForm?.get('calculateMargins.marginTP.p6').touched ||
                          riskAnalysisForm?.get('calculateMargins.marginTP.p6').dirty)
                      ">
                      {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="risk-analysis-pymes__space--20"></div>
            <div class="risk-analysis-pymes__grid-col--8">
              <div class="risk-analysis-pymes__col-span--2 risk-analysis-pymes__col-start--7">
                <button class="risk-analysis-pymes__button-query"
                  (click)="isUserSpanish ? calculatearginMatchPrice() : calculatearginMatchPricePT()"
                  [disabled]="!riskAnalysisForm?.get('calculateMargins').valid">
                  {{ 'NEW_CONTRACTS.CALCULATE' | i18nextEager }}
                </button>
              </div>
            </div>
          </div>
          <div *ngIf="showCalculation">
            <div class="risk-analysis-pymes__section">
              <div class="risk-analysis-pymes__header--result">
                <h2>{{ 'NEW_CONTRACTS.RESULT_SIMULATION' | i18nextEager }}</h2>
                <div *ngIf="!resultCalculation" class="risk-analysis-pymes__header--info">
                  {{ 'NEW_CONTRACTS.NO_RESULT' | i18nextEager }}
                </div>
              </div>
              <div *ngIf="resultCalculation" class="risk-analysis-pymes__select-calculate-commission__result">
                <table>
                  <tr>
                    <th id="price"></th>
                    <th id="p1">P1</th>
                    <th id="p2">P2</th>
                    <th id="p3">P3</th>
                    <th id="p4">{{ feeAux !== '2.0TD' ? 'P4' : '' }}</th>
                    <th *ngIf="isUserSpanish" id="p5">{{ feeAux !== '2.0TD' ? 'P5' : '' }}</th>
                    <th *ngIf="isUserSpanish" id="p6">{{ feeAux !== '2.0TD' ? 'P6' : '' }}</th>
                  </tr>
                  <tr *ngIf="resultTP.length > 0">
                    <td>
                      TP<span class="units">{{ 'COMMONS.EUROS_KW_YEAR' | i18nextEager }}</span>
                    </td>
                    <td *ngFor="let tp of resultTP; let i = index">
                      {{ (feeAux === '2.0TD' && i >= 3 ? null : tp) | number: '1.6-6' }}
                    </td>
                  </tr>
                  <tr *ngIf="resultTE.length > 0 && fixPrice">
                    <td>
                      TE<span class="units">{{ 'COMMONS.EUROS_KWH' | i18nextEager }}</span>
                    </td>
                    <td *ngFor="let te of resultTE; let i = index">
                      {{ (feeAux === '2.0TD' && i >= 3 ? null : te) | number: '1.6-6' }}
                    </td>
                  </tr>
                  <tr *ngIf="resultAI.length > 0 && !fixPrice">
                    <td>
                      Ai<span class="units">{{ 'COMMONS.EUROS_KWH' | i18nextEager }}</span>
                    </td>
                    <td *ngFor="let ai of resultAI; let i = index">
                      {{ (feeAux === '2.0TD' && i >= 3 ? null : ai ? ai + camaignRealTE[i] : ai) | number: '1.6-6' }}
                    </td>
                  </tr>
                  <tr *ngIf="campaignKI.length > 0 && !fixPrice">
                    <td>
                      Ki
                    </td>
                    <td *ngFor="let ki of campaignKI; let i = index">
                      {{ (feeAux === '2.0TD' && i >= 3 ? null : ki) | number: '1.3-6' }}
                    </td>
                  </tr>
                </table>

                <div formGroupName="enterMargins">
                  <div class="risk-analysis-pymes__grid-col--7">
                    <div class="risk-analysis-pymes__title-terms">
                      <div class="risk-analysis-pymes__title-terms--bold">
                        {{ 'NEW_CONTRACTS.MARGIN_TE' | i18nextEager }}
                      </div>
                      <div>
                        <span class="risk-analysis-pymes__title-terms--bold">{{
                          'NEW_CONTRACTS.EURO' | i18nextEager
                          }}</span>
                        <span class="risk-analysis-pymes__title-terms--normal">{{
                          'NEW_CONTRACTS.MW_HOUR_2' | i18nextEager
                          }}</span>
                      </div>
                    </div>
                    <div class="risk-analysis-pymes__row-values--border-red">
                      <div class="risk-analysis-pymes__row-values--col-value">
                        <div class="risk-analysis-pymes__row-values--center">
                          <div class="risk-analysis-pymes__row-values--value">
                            {{ riskAnalysisForm.get('enterMargins.marginsTE').value | number: '1.0-2' }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="isUserSpanish" class="risk-analysis-pymes__title-terms--right">
                      <div class="risk-analysis-pymes__title-terms--bold">
                        {{ 'NEW_CONTRACTS.MARGIN_TP' | i18nextEager }}
                      </div>
                      <div>
                        <span class="risk-analysis-pymes__title-terms--bold">{{
                          'NEW_CONTRACTS.EURO' | i18nextEager
                          }}</span>
                        <span class="risk-analysis-pymes__title-terms--normal">{{
                          'NEW_CONTRACTS.KW_ANY' | i18nextEager
                          }}</span>
                      </div>
                    </div>
                    <div *ngIf="isUserSpanish" class="risk-analysis-pymes__row-values--border-red">
                      <div class="risk-analysis-pymes__row-values--col-value">
                        <div class="risk-analysis-pymes__row-values--center">
                          <div class="risk-analysis-pymes__row-values--value">
                            {{ riskAnalysisForm.get('enterMargins.marginTP').value | number: '1.0-2' }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- <ng-container *ngIf="canSettlements">
                      <div class="risk-analysis-pymes__title-terms--right">
                        <div class="risk-analysis-pymes__title-terms--bold">
                          {{ 'NEW_CONTRACTS.COMMISSION' | i18nextEager }}
                        </div>
                        <div>
                          <span class="risk-analysis-pymes__title-terms--bold">
                            {{ 'NEW_CONTRACTS.EURO' | i18nextEager }}
                          </span>
                        </div>
                      </div>
                      <div class="risk-analysis-pymes__row-values--border-red">
                        <div class="risk-analysis-pymes__row-values--col-value">
                          <div class="risk-analysis-pymes__row-values--center">
                            <div class="risk-analysis-pymes__row-values--value">
                              {{ riskAnalysisForm.get('commission').value | number: '1.0-2' }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div [hidden]="campaignBase" class="risk-analysis-pymes__section risk-analysis-pymes__section--not-padding-y">
        <div class="risk-analysis-pymes__center">
          <app-custom-select class="width100" [label]="'NEW_CONTRACTS.LEVEL'" [controlName]="'level'"
            [values]="campaignLevels" [defaultValue]="defaultValueLevel" (onChange)="changeLevel($event)"
            [disabled]="levelsSelectDisabled">
          </app-custom-select>
        </div>
      </div>
    </form>
  </div>
</section>